import FilledAptitudeTestQuestion from 'src/entities/FilledAptitudeTestQuestion';

export default class FilledAptitudeTestSection {
  sectionId?: number;
  questions?: Array<FilledAptitudeTestQuestion>;
  passed?: boolean;

  constructor(entity: FilledAptitudeTestSection) {
    this.sectionId = entity.sectionId || undefined;
    this.passed = entity.passed || undefined;
    this.questions = entity.questions ?
      entity.questions.map(question => new FilledAptitudeTestQuestion(question)) : [];
  }
}


// WEBPACK FOOTER //
// ./src/entities/FilledAptitudeTestSection.tsx